var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCitiesLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 701.9 79.4",
    style: {
      enableBackground: "new 0 0 701.9 79.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.6,1.1v77.2H60.4V31.1L43.9,59.9h-5l25.9-45V74h6.5V5.5h-8.5L31.6,59.8L15.2,31.1v47.2H0V1.1h15.4l18.9,33 l-2.5,4.3l-18.9-33H4.3V74h6.5V14.9l20.8,36.2l28.5-50L75.6,1.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.9,63.8v14.5H96.2V1.1h47.1v14.5h-31.9v9H107V11.3h31.9V5.5h-38.4V74h39.1v-5.9H107V30.6h35v14.5h-24.2 v-4.3h19.9v-5.9h-26.4v28.9H143.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.9,1.1v14.5h-13.6v-4.3h9.3V5.5h-15.8v72.9h-15.1V5.5h-15.8v5.9h9.3v4.3h-13.7V1.1H180V74h6.5V1.1H210.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.4,25.6c0,9.4-4.1,17-11.3,21l-2.5-3.5c6.5-3.8,9.5-9.9,9.5-17.6c0-12.4-9.2-20.2-23.4-20.2h-22.3V74h6.5 V36.5h4.5L268,74h7.6l-27.8-37.5h4.2c9.5,0,12.3-5.1,12.3-10.9c0-6.5-4.6-10-11.8-10h-12.3v15h-4.3V11.3h16.6 c9.8,0,16.1,5.6,16.1,14.3c0,8.2-4.6,13.7-12.5,14.8l28.1,37.9h-18.4l-25.5-34.8v34.8h-15.1V1.1h26.6 C269.5,1.1,279.4,11.9,279.4,25.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.4,39.7c0,21.7-12.3,39.7-33.9,39.7s-33.9-18.1-33.9-39.7S305.9,0,327.5,0c0.7,0,1.4,0.1,2.2,0.1v10.2 c14.3,1.3,20.9,15.9,20.9,29.4c0,14.2-7.2,29.5-23.1,29.5s-23.1-15.3-23.1-29.5c0-11.3,4.6-23.2,14.4-27.7v4.9 c-7.3,4.5-10.1,14.7-10.1,22.8c0,10.8,5,25.2,18.8,25.2s18.8-14.4,18.8-25.2s-5-25.1-18.8-25.1c-0.7,0-1.5,0-2.2,0.1V4.4 c-18.9,1.3-27.4,18.4-27.4,35.3c0,17.6,9.2,35.4,29.6,35.4s29.6-17.8,29.6-35.4c0-14.8-6.5-29.8-20.9-34.1V1.1 C352.4,5.3,361.4,21.1,361.4,39.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M438.4,1.1l-27.7,77.2h-2.8L382,5.5h-6.8l26.1,72.9h-4.6L369.1,1.1h16l24.2,68.3l22.9-64h-6.8L409.3,51 l-2.3-6.5l15.3-43.3H438.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499,63.8v14.5h-47.8V1.1h47.1v14.5h-31.9v9h-4.3V11.3H494V5.5h-38.4V74h39.1v-5.9H462V30.6h35v14.5h-24.2v-4.3 h19.9v-5.9h-26.4v28.9H499z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571.4,25.6c0,9.4-4.1,17-11.3,21l-2.5-3.5c6.5-3.8,9.5-9.9,9.5-17.6c0-12.4-9.2-20.2-23.3-20.2h-22.3V74h6.5 V36.5h4.5L559.9,74h7.6l-27.8-37.5h4.2c9.5,0,12.3-5.1,12.3-10.9c0-6.5-4.6-10-11.8-10h-12.3v15h-4.3V11.3h16.6 c9.8,0,16.1,5.6,16.1,14.3c0,8.2-4.6,13.7-12.5,14.8l28.1,37.9h-18.5l-25.5-34.8v34.8H517V1.1h26.7C561.5,1.1,571.4,11.9,571.4,25.6 z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M637.4,56.6c0,15-11.8,22.8-28.1,22.8c-10.9,0-19.2-3-26.9-7.2l5.3-14c7.1,3.7,14.6,6.6,21.7,6.6 c8.3,0,13-2.5,13-8.3c0-10-6.7-12.6-13.2-16.2s-12.8-7.2-12.8-17.3c0-6.6,4.5-12.9,16-12.9c5.3,0.1,10.6,1.3,15.5,3.5l2.2-5.9 c-4.6-2.1-8.2-3.3-17.7-3.3c-12.3,0-22.4,6.3-22.4,18.9c0,11.2,6.2,17.7,14.2,21.3l-1.5,4.1c-11-5-17.1-13.5-17.1-25.4 C585.5,7.9,597.9,0,612.2,0c12,0,16.6,2.2,23.1,5.5l-5.2,14c-6.3-3.2-11.8-5-17.9-5c-7.7,0-11.7,3.1-11.7,8.6 c0,7.9,5,10.5,10.6,13.5c7.2,3.9,15.4,7.7,15.4,19.9c0,4.7-2.2,12.6-17.3,12.6c-5.7,0-12.2-1.7-19.3-5l-2.2,5.9 c6.7,3.3,14,5,21.5,4.9c12.1,0,23.8-4.6,23.8-18.5c0-11.6-5.5-19.4-17.9-24.5l1.4-4.1C630.1,33.6,637.4,42.4,637.4,56.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M701.9,63.8v14.5h-47.8V1.1h47.1v14.5h-31.9v9H665V11.3h31.9V5.5h-38.4V74h39.1v-5.9H665V30.6h35v14.5h-24.2 v-4.3h19.9v-5.9h-26.4v28.9H701.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitiesLogo);
export default __webpack_public_path__ + "static/media/cities-logo.1d50bf5d3572d6cf7c87ad8d6936d58d.svg";
export { ForwardRef as ReactComponent };